import { getStudentInfo, getUserData, getUtterance } from "../../../../services/API"
import getNetworkPingPromise from "./getNetworkPingPromise"
import runNetworkPingUnifiedSocket from "./runNetworkPingUnifiedSocket"


export default function getAllNetworkPingPromises() {

    const checkCloudFrontAssetRoot = getNetworkPingPromise({name: 'cloudfront', url: `https://${process.env.ASSET_ROOT}` })

    const checkUnifiedSocket = getNetworkPingPromise({
        name: 'unified socket',
        apiFunction: () => runNetworkPingUnifiedSocket(),
        passIf: (result) => { 
            return result
        }
    })
    
    const checkUtteranceService = getNetworkPingPromise({
        name: 'aws utterance service',
        apiFunction: () => getUtterance('test'),
        passIf: (data) => data.id
    })

    // This will always run, but magic can skip using the same but stubbed condition to pass the check.
    const magicBox = getNetworkPingPromise({
        name: 'magic box',
        apiFunction: () => {
            if(getUserData().skipMagic){
                return Promise.resolve({ schoolId: true }) // just return a passing condition
            }
            return getStudentInfo(getUserData().userName)
        },
        passIf: (data) => data.schoolId
    })

    const networkCheckPromises = [
        checkCloudFrontAssetRoot,
        checkUnifiedSocket,
        checkUtteranceService,
        magicBox
    ]

    return networkCheckPromises
}